export default __webpack_public_path__ + "static/media/international-women-s-day-2.46c75636.png";